import { ELoadingType, Loading } from '@bilibili-maoer/prelude'

import { Outlet } from 'react-router-dom'
import { usePrevious } from 'react-use'

import { Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

import { useAppDispatch, useAppSelector } from '~/app/hooks'
import { DialogButton } from '~/core/components/dialog-button'
import { Header } from '~/core/components/header/header'
import SystemSlice from '~/core/slices/system'
import { UserApi } from '~/services/fm/user'

const ErrorDialog = (props: { info: string | undefined; onClick: () => void }) => {
  const prevInfo = usePrevious(props.info)
  return (
    <Dialog open={props.info !== undefined}>
      <DialogTitle>错误</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.info ?? prevInfo}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <DialogButton variant="primary" onClick={props.onClick}>
          确认
        </DialogButton>
      </DialogActions>
    </Dialog>
  )
}

export const Layout = () => {
  const dispatch = useAppDispatch()
  const userInfo = UserApi.getUserInfo.useQuery()

  const error = useAppSelector((s) => s.System.errors.at(-1))

  if (!userInfo.data) {
    return <Loading type={ELoadingType.Cat} style={{ margin: '150px auto' }} />
  }

  return (
    <>
      <Header />

      {/* eslint-disable-next-line @typescript-eslint/no-magic-numbers */}
      <Container maxWidth="xl" sx={{ py: [2, 4], overflowX: 'auto' }}>
        <Outlet />
      </Container>

      <ErrorDialog
        info={error}
        onClick={() => {
          // TODO: 后续根据具体需求还要实现 replaceError 等特殊功能
          dispatch(SystemSlice.actions.popError())
        }}
      />
    </>
  )
}
